// extracted by mini-css-extract-plugin
module.exports = {"eventBox":"events-module--eventBox--2OWc0","eventIcon":"events-module--eventIcon--25YsS","eventContent":"events-module--eventContent--3ArGl"};